import httpRequest from "services/httpRequest";

const prefix = "/api/invoice";

export const onGetInvoicesPage = async params => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
    params: { ...params },
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};

export const onGetInvoice = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params}`,
    method: "GET",
  });
  if (result?.data) {
    return result?.data;
  }
  return {};
};

export const onUpdateInvoice = async params => {
  const result = await httpRequest({
    url: `${prefix}/${params}`,
    method: "PUT",
    successMessage: "toast.charge_invoice_sucess",
  });
  return result;
};

export const onDoGetAllInvoices = async params => {
  const result = await httpRequest({
    url: `${prefix}/all/${params}`,
    method: "GET",
  });
  return result;
};
